import { graphql } from '@/gql';
import type { CancelScheduledDeliveryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelScheduledDelivery = async ({ deliveryOrderId, reason }: CancelScheduledDeliveryMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation cancelScheduledDelivery($deliveryOrderId: String!, $reason: String!) {
        cancelScheduledDelivery(deliveryOrderId: $deliveryOrderId, reason: $reason)
      }
    `),
    variables: {
      deliveryOrderId,
      reason,
    },
  });

  return response.data?.cancelScheduledDelivery ?? false;
};
